import Vue from 'vue'
import Router from 'vue-router'

const index = () => import( /* webpackChunkName: "home" */ './views/index.vue')
const nopermissions = () => import( /* webpackChunkName: "home" */ './views/nopermissions.vue')
const login = () => import( /* webpackChunkName: "home" */ './views/login.vue')
const home = () => import( /* webpackChunkName: "home" */ './views/Home.vue')

const unpaidList = () => import( /* webpackChunkName: "pay" */ './views/pay/unpaidList.vue')
const payList = () => import( /* webpackChunkName: "pay" */ './views/pay/payList.vue')
const unpaid = () => import( /* webpackChunkName: "pay" */ './views/pay/unpaid.vue')
const history = () => import( /* webpackChunkName: "pay" */ './views/pay/history.vue')
const successPage = () => import( /* webpackChunkName: "pay" */ './views/pay/successPage.vue')

const expenseDepositList = () => import( /* webpackChunkName: "expenseDeposit" */ './views/expenseDeposit/list.vue')

const invoiceList = () => import( /* webpackChunkName: "invoice" */ './views/invoice/list.vue')
const invoiceSuccess = () => import( /* webpackChunkName: "invoice" */ './views/invoice/success.vue')
const invoiceHistory = () => import( /* webpackChunkName: "invoice" */ './views/invoice/history.vue')
const invoiceHistoryDetail = () => import( /* webpackChunkName: "invoice" */ './views/invoice/historyDetail.vue')



import commonUtil from './lib/plugins/commonUtil'

Vue.use(Router)

const router = new Router({
  mode: "history",
  // 解决vue框架页面跳转有白色不可追踪色块的bug
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    { path: '/index', name: 'index', component: index },
    { path: '/nopermissions', name: 'nopermissions', component: nopermissions },
    { path: '/login', name: 'login', component: login },
    { path: '/', name: 'home', component: home, children: 
      [
        { path: '/pay/unpaidList', name: 'unpaidList', component: unpaidList },
        { path: '/pay/payList', name: 'payList', component: payList },
        { path: '/pay/unpaid', name: 'unpaid', component: unpaid },
        { path: '/pay/history', name: 'history', component: history },
        { path: '/pay/successPage', name: 'successPage', component: successPage },
        
        { path: '/expenseDeposit/list', name: 'expenseDepositList', component: expenseDepositList },

        { path: '/invoice/list', name: 'invoiceList', component: invoiceList },
        { path: '/invoice/success', name: 'invoiceSuccess', component: invoiceSuccess },
        { path: '/invoice/history', name: 'invoiceHistory', component: invoiceHistory },
        { path: '/invoice/history/detail', name: 'invoiceHistoryDetail', component: invoiceHistoryDetail },
        
      ]
    },
  ]
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let token = commonUtil.getCookie('zxjf')
 
    if (token === 'null' || token === '') {
      next('/login');
    } else {
      next();
    }
  }
});

export default router;